import { useCallback, useState, useRef, useEffect } from 'react';
import useEventCallback from '../utils/useEventCallback.mjs';

const noop = () => void 0;
const useControllableState = ({
  prop,
  defaultProp,
  onChange
}) => {
  const [uncontrolledState, setUncontrolledState] = useUncontrolledState({
    defaultProp,
    onChange
  });
  const controlled = prop !== void 0;
  const value = controlled ? prop : uncontrolledState;
  const onChangeProp = useEventCallback(onChange ?? noop);
  const setValue = useCallback(
    (next) => {
      if (controlled) {
        const setter = next;
        const nextValue = typeof next === "function" ? setter(value) : next;
        if (value !== nextValue) {
          onChangeProp(nextValue);
        }
      } else {
        setUncontrolledState(next);
      }
    },
    [controlled, onChangeProp, setUncontrolledState, value]
  );
  return [value, useEventCallback(setValue)];
};
function useUncontrolledState({
  defaultProp,
  onChange
}) {
  const uncontrolledState = useState(defaultProp);
  const [value] = uncontrolledState;
  const prevValueRef = useRef(value);
  const handleChange = useEventCallback(onChange ?? noop);
  useEffect(() => {
    if (prevValueRef.current !== value) {
      handleChange(value);
      prevValueRef.current = value;
    }
  }, [value, prevValueRef, handleChange]);
  return uncontrolledState;
}

export { useControllableState as default };
//# sourceMappingURL=useControllableState.mjs.map
